import React from 'react';
import { PricingTierItem } from './PricingTierItem';
import { tier1, tier2, tier3 } from '../../data/tiers';
import { TierItem } from './elements/TierItem';
import { useWindowDimensions } from '../../hooks/useWindowDimensions';

interface IPricingTiers {}

export const PricingTiers: React.FC<IPricingTiers> = () => {
    const { isMobile } = useWindowDimensions();

    return (
        <section className="relative mx-auto flex w-full max-w-7xl grid-cols-3 flex-col gap-4 px-4 md:grid md:gap-2 md:px-0">
            <PricingTierItem
                tier={tier1}
                color="cyan"
                animationDirection={isMobile || isMobile === null ? 'top' : 'left'}
            >
                <TierItem color="neutral" label="Quick starter" />
                <TierItem color="neutral" label="All features" />
                <TierItem color="neutral" label="Single Tenant" />
                <TierItem color="neutral" label="AI Translations" />
                <TierItem color="primary" label="Printformer integration" />
            </PricingTierItem>
            <PricingTierItem tier={tier2} color="magenta" popular={true} animationDirection="top">
                <TierItem color="primary" label="Your platform" />
                <TierItem color="primary" label="Real multi-tenant" />
                <TierItem color="primary" label="Onboard new tenants with ease" />
                <TierItem color="primary" label="Printformer integration" />
            </PricingTierItem>
            <PricingTierItem
                tier={tier3}
                color="yellow"
                animationDirection={isMobile || isMobile === null ? 'top' : 'right'}
            >
                <TierItem color="neutral" label="Adapted to your specific domain needs" />
                <TierItem color="neutral" label="Will never become legacy" />
                <TierItem color="neutral" label="All inclusive" />
            </PricingTierItem>
        </section>
    );
};
